/* eslint-disable */
export default {
// getterMessageList: (state) => {
//   if (typeof state.message === 'string') {
//     return [
//       state.message,
//     ];
//   }
//   return state.message;
// },
// getterIsSingleMessage: (state, getters) => getters.getterMessageList.length === 1,
};
